import {FulfilmentRequestsService} from '../../services/fulfilment/fulfilment.service';
import {QueryBuilder} from '../../services/query-builder.service';
import {UserService} from 'src/app/angularJS/services/user/user.service';

const getFulfilmentRequestsSummaryByStatus = (
  userService: UserService,
  fulfilmentRequestsService: FulfilmentRequestsService,
  $rootScope: ng.IRootScopeService) => {
  if (userService.permissions.ui &&
    userService.permissions.ui['fulfilment-dashboard'] &&
    userService.permissions.ui['fulfilment-dashboard'].canAccess) {

    const backTo = <any>moment().subtract(1, 'd').toISOString().substr(0, 16);

    return fulfilmentRequestsService.getFulfilmentRequestSummary('state.name', `state.timestamp >= ${backTo}Z`).then((response) => {
      $rootScope.showSpinner = false;
      return response;
    });
  } else {
    return {};
  }
};

getFulfilmentRequestsSummaryByStatus.$inject = ['userService', 'fulfilmentRequestsService', '$rootScope'];

const getFulfilmentRequests = (
  fulfilmentRequestsService: FulfilmentRequestsService,
  $stateParams: ng.ui.IStateParamsService,
  queryBuilderService: QueryBuilder,
  $rootScope: ng.IRootScopeService) => {
  let fieldName = '';
  let query = queryBuilderService.newParam();
  let {queryName, filterQuery} = $stateParams;

  if (queryName !== '') {
    if (queryName.includes('catalogues')) {
      fieldName = 'actions.variantExternalId';
    } else {
      fieldName = 'state.name';
    }
    query = queryBuilderService.fieldIs(fieldName, queryName)
  }

  if (filterQuery) {
    query.and().isGreaterOrEqualTo('state.timestamp', filterQuery)
  }

  query.sortBy([
    {columnName: 'timestamp', direction: 'desc'}
  ]);

  return fulfilmentRequestsService.getFulfilmentRequests(1, 15, query ? query.getParam() : undefined).then(response => {
    $rootScope.showSpinner = false;
    return response
  });
};

getFulfilmentRequests.$inject = ['fulfilmentRequestsService', '$stateParams', 'QueryBuilder', '$rootScope'];

const getFulFilmentRequestsByCatalogueVariant = (
  userService: UserService,
  fulfilmentRequestsService: FulfilmentRequestsService,
  $rootScope: ng.IRootScopeService) => {
  if (userService.permissions.ui &&
    userService.permissions.ui['fulfilment-dashboard'] &&
    userService.permissions.ui['fulfilment-dashboard'].canAccess) {

    return fulfilmentRequestsService.getFulfilmentRequestSummary('actions.variantExternalId').then(response => {
      $rootScope.showSpinner = false;
      return response
    });
  } else {
    return {};
  }
};

getFulFilmentRequestsByCatalogueVariant.$inject = ['userService', 'fulfilmentRequestsService', '$rootScope'];

const getFulfilmentRequest = (
  fulfilmentRequestsService: FulfilmentRequestsService,
  $stateParams: ng.ui.IStateParamsService,
  $rootScope: ng.IRootScopeService) => {
  return fulfilmentRequestsService.getFulfilmentRequest($stateParams.externalId).then(response => {
    $rootScope.showSpinner = false;
    return response
  });
};

getFulfilmentRequest.$inject = ['fulfilmentRequestsService', '$stateParams', '$rootScope'];

export const initialise = () => {
  angular
    .module('actora.fulfilment')
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
      $locationProvider.hashPrefix('');
      $stateProvider.state('fulfilment-dashboard', {
        url: '/fulfilment/dashboard',
        templateUrl: 'app/angularJS/features/fulfilment/fulfilment-dashboard/fulfilment-dashboard.html',
        controller: 'FulfilmentDashboardController',
        controllerAs: 'vm',
        parent: 'common',
        resolve: {
          fulFilmentRequestsByStatus: getFulfilmentRequestsSummaryByStatus
        }
      }).state('fulfilment-requests', {
        url: '/fulfilment/requests/:queryName/:filterQuery',
        templateUrl: 'app/angularJS/features/fulfilment/fulfilment-requests/fulfilment-requests.html',
        controller: 'FulfilmentRequestsController',
        controllerAs: 'vm',
        parent: 'common',
        params: {
          queryName: {
            value: '',
            squash: true
          },
          filterQuery: {
            value: '',
            squash: true
          }
        }
      }).state('fulfilment-request', {
        url: '/fulfilment/request/:externalId',
        template: '<div ui-view></div>',
        controller: 'FulfilmentRequestController',
        controllerAs: 'vm',
        parent: 'common',
        params: {
          externalId: {
            value: undefined,
            squash: true
          }
        },
        resolve: {
          fulfilmentRequest: getFulfilmentRequest
        }
      }).state('fulfilment-request.summary', {
        url: '/summary',
        templateUrl: 'app/angularJS/features/fulfilment/fulfilment-request/summary/fulfilment-request-summary.html',
        controller: 'FulfilmentRequestSummaryController',
        controllerAs: 'vm',
        data: {
          selectedTab: 0
        }
      }).state('fulfilment-request.timeline', {
        url: '/timeline',
        templateUrl: 'app/angularJS/features/fulfilment/fulfilment-request/timeline/fulfilment-request-timeline.html',
        controller: 'FulfilmentRequestTimelineController',
        controllerAs: 'vm',
        data: {
          selectedTab: 1
        }
      }).state('fulfilment-request.details', {
        url: '/details',
        templateUrl: 'app/angularJS/features/fulfilment/fulfilment-request/details/fulfilment-request-details.html',
        controller: 'FulfilmentRequestDetailsController',
        controllerAs: 'vm',
        data: {
          selectedTab: 2
        }
      })
      $urlRouterProvider.otherwise('/');
    }]);
};
